import Vue from 'vue'
import VueI18n from 'vue-i18n'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import Vant from 'vant';
import { Message } from 'element-ui';

import 'element-ui/lib/theme-chalk/index.css'
import './resource/commonCss/base.css'
import './resource/commonCss/detail.css'
import './resource/commonCss/index.css'
import './resource/commonCss/nav.css'
import './resource/commonCss/footer.css'
import 'vant/lib/index.css';

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import '@/index.css'

Vue.use(VueQuillEditor)
Vue.use(ElementUI)
Vue.use(Vant);

//全局变量
let GlobalConfig = {
  baseUrl:'/mainsys', //基础Url，主系统url
  // baseUrl:'/lims', //基础Url，odig-lims 配置地址
};

var targetUrl = '/manager'//线上
// var targetUrl = 'http://192.168.19.6:8080'//线下
// var targetUrl = 'http://localhost:8081'//线下
// var targetUrl = 'http://192.168.18.24:8780/'//线下
// var targetUrl = 'http://soft.odig.com.cn/mainsys'//线下

// 将提交数据转化为formData
function translateForm(data) {
  var fd = new FormData();
  for (var key in data) {
    if(data[key] || data[key] === 0){
      fd.append(key, data[key]);
    }
  }
  return fd;
};

Vue.prototype.translateForm = translateForm;
Vue.prototype.targetUrl = targetUrl;
Vue.prototype.GlobalConfig = GlobalConfig;
Vue.config.productionTip = true
axios.defaults.baseURL = GlobalConfig.baseUrl;

// 响应拦截器
axios.interceptors.response.use(
  response => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  error => { //异常情况
    if (error.response.status) {
      switch (error.response.status) {
        // 403 token过期或未登录
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
        case 401:
          Message.error('登录过期，请重新登录')
          // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          setTimeout(() => {
            router.replace({
              path: '/',
              query: {
                redirect: router.currentRoute.fullPath
              }
            });
          }, 1000);
          break;
        // 404请求不存在
        case 404:
          Message.error('网络请求不存在');
          break;
        // 其他错误，直接抛出错误提示
        default:
          Message.error(error.response.data.message)
      }
      return Promise.reject(error.response);
    }
  });

Vue.prototype.friendshipLink = {
  //友情链接；outer-外部链接 inner-内部链接 res-中心资源链接 top-顶部导航链接
  outer:[],
  inner:[],
  res:[],
  top:[],
}
//获取站点信息
Vue.prototype.siteInfo = {
  siteName:'加载中……',
  contentString:'加载中……',
  siteLogo:'',
};
axios.post( "/cmsapi/getSiteInfo", {}, { //站点信息
  headers: {'Content-Type': 'application/x-www-form-urlencoded'}
}).then(res=>{
  Vue.prototype.siteInfo = res.data;
  axios.post('/cmsapi/getFriendshipLink').then(res=>{
    let recData = res.data;
    if(recData) {
      Vue.prototype.friendshipLink = recData;
    }
    //全部加载完毕再执行渲染
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }).catch(err=>{
    throw err;
  });
}).catch(err=>{
  console.error(err);
});


